import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { reservationLedgerQueries } from '@/services/dashboard/reservationLedger/reservationLedger.queries';
import { revalidate } from '@/services/revalidate/revalidate';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useVisitCodeConfirmation = () => {
  const queryClient = useQueryClient();

  const { mutateAsync } = useMutation('verifyReservationCode', {
    onSuccess: async (res) => {
      toast.success(res.message);
      await queryClient.invalidateQueries({ queryKey: reservationLedgerQueries.all() });
      await revalidate(['totalReferralPoint', 'refers', 'points']);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });
  return { mutateAsync };
};
